/* eslint-disable no-constant-condition */
import { takeEvery, put, call, all} from 'redux-saga/effects'
import { invocatorServices } from '../services'
import {API_URL} from '../config/config'

import * as CONSTANTS from '../constants/constants'

export function* createPermission(payload){
  try {
    console.log(payload)
    const result = yield call(invocatorServices.postCall,`${API_URL}/api/permissions/create`, payload);
    yield put({type: CONSTANTS.CREATE_PERMISSION_SAVE_SUCCESS, response: result});
  } catch (e) {
    yield put({type: CONSTANTS.CREATE_PERMISSION_SAVE_ERROR, message: e.message});
  }
}

export default function* root() {
  
  yield takeEvery(CONSTANTS.CREATE_PERMISSION_SAVE_LOADING, createPermission)

  yield all([])
}

